import ToolButton from "./toolButton";

// fullScreenTool
export default class FullScreenTool extends ToolButton {
  /* Get the element you want displayed in fullscreen mode (a video in this example): */
  private elem = document.documentElement;
  deactivateTool() {
    // console.log("FullScreenTool deactivateTool")
  }

  activateTool(event: any) {
    if (this.toolbar) {
      this.toolbar.setActiveTool(this as ToolButton);
    }
    if (1 >= outerHeight - innerHeight) {
      this.closeFullscreen();
    } else {
      this.openFullscreen();
    }
    this.toolbar.setPanAsActiveTool();
  }

  /* When the openFullscreen() function is executed, open the video in fullscreen.
    Note that we must include prefixes for different browsers, as they don't support the requestFullscreen method yet */
  private openFullscreen() {
    if (this.elem === null) {
      return;
    }

    try {
      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen();
      } else if (this.elem.mozRequestFullScreen) {
        /* Firefox */
        this.elem.mozRequestFullScreen();
      } else if (this.elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.elem.webkitRequestFullscreen();
      } else if (this.elem.msRequestFullscreen) {
        /* IE/Edge */
        this.elem.msRequestFullscreen();
      }
    } catch (error) {
      console.error("Error: in fullScreenTool.openFullScreen " + +error.message);
    }
  }

  /* Close fullscreen */
  private closeFullscreen() {
    try {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen();
      }
    } catch (error) {
      console.error("Error: in fullScreenTool.openFullScreen " + +error.message);
    }
  }
}
